export function cssTimeToMilliseconds(timeString) {
  const num = parseFloat(timeString, 10);
  let unit = timeString.match(/m?s/);
  let milliseconds;

  if (unit) {
    unit = unit[0];
  }

  switch (unit) {
    case 's': // seconds
      milliseconds = num * 1000;
      break;
    case 'ms': // milliseconds
      milliseconds = num;
      break;
    default:
      milliseconds = 0;
      break;
  }

  return milliseconds;
}

export function setCookie(name, value, expireDays = 30) {
  const date = new Date();
  date.setTime(date.getTime() + expireDays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}

export function getCookie(cookieName) {
  const name = cookieName + '=';
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '';
}
